// extracted by mini-css-extract-plugin
module.exports = {"appbar":"_2XFLM","_dark":"CBNA-","_fixed":"_10wbh","_small":"_2GTOD","content":"_1g7OF","logo":"_1njTC","item":"_26kFD","list":"IBvkr","_badge":"_3qk2P","loader":"_13Ap2"};